<template>
  <div class="side-button-bar">
    <img :src="require('@/assets/images/sideButtonBar/up.png')" class="top"/>
    <slot></slot>
    <img :src="require('@/assets/images/sideButtonBar/down.png')" class="bottom"/>
  </div>
</template>

<script>
export default {
  name: 'SideButtonBar'
}
</script>

<style scoped>
.side-button-bar {
  display: flex;
  flex-direction: column;
  width: 220px;
  background-color: #fff;
  height: 100%;
  overflow: auto;
}

.side-button-bar .top{
    margin-bottom: 7px;
}

.side-button-bar .bottom{
    margin-top: auto;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0,0,0,0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

</style>



// WEBPACK FOOTER //
// src/components/SideButtonBar.vue